import { Link, useLocation, useNavigate } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  //  Hide CTA on /start-brand
  const hideStartBrandCTA = location.pathname === "/start-brand";

  // Mapping for deep links
  const capabilitiesLinks = [
    { label: "Branding", id: "cat_branding" },
    { label: "Apparel", id: "cat_uniforms" },
    { label: "Gifting", id: "cat_gifting" },
    { label: "Specialty", id: "cat_ethnic" },
  ];

  // Function to handle smooth scrolling to Home sections
  const scrollToSection = (sectionId) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const headerOffset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      }, 300); // Increased timeout slightly to ensure DOM is ready
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        const headerOffset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }
  };

  return (
    <footer className="relative w-full bg-[#080808] pt-20 overflow-hidden text-white">
      {/* ... Background Effects & Top CTA (Unchanged) ... */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-red-900/20 rounded-full blur-[120px] pointer-events-none -translate-y-1/2 translate-x-1/3"></div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12 flex flex-col h-full">
        {!hideStartBrandCTA && (
          <>
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-16">
              <h2 className="text-4xl md:text-5xl font-medium tracking-tight">
                Want to launch your <br /> own brand?
              </h2>
              <Link
                to="/start-brand"
                className="group bg-[#D91F26] hover:bg-[#b0191f] text-white px-8 py-4 rounded-[4px] flex items-center gap-3 font-medium transition-all duration-300"
              >
                Start Your Brand
                <svg
                  className="w-5 h-5 transition-transform group-hover:translate-x-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                  />
                </svg>
              </Link>
            </div>
            <hr className="border-gray-800 mb-16" />
          </>
        )}

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-24">
          {/* Brand Info */}
          <div className="md:col-span-6 pr-0 md:pr-16">
            <div
              className="flex items-center gap-2 mb-6 cursor-pointer"
              onClick={() => navigate("/")}
            >
              <img src="/images/alldoer-logo.svg" alt="logo" className="brightness-0 invert" />
            </div>
            <p className="text-gray-500 leading-relaxed max-w-md">
              Your trusted global sourcing partner. We connect international
              brands with high-quality custom manufacturing.
            </p>
          </div>

          <div className="hidden md:block md:col-span-2"></div>

          {/* Capabilities Links - UPDATED TO MAP OBJECTS */}
          <div className="md:col-span-2">
            <h4 className="text-lg font-medium text-white mb-6">
              Capabilities
            </h4>
            <ul className="space-y-4">
              {capabilitiesLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-500 hover:text-white transition-colors bg-transparent border-none cursor-pointer text-left p-0"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div className="md:col-span-2">
            <h4 className="text-lg font-medium text-white mb-6">Company</h4>
            <ul className="space-y-4">
              <li>
                <button
                  onClick={() => scrollToSection("contact")}
                  className="text-gray-500 hover:text-white transition-colors bg-transparent border-none cursor-pointer text-left p-0"
                >
                  Contact Us
                </button>
              </li>
              <li>
                <Link
                  to="/start-brand"
                  className="text-gray-500 hover:text-white transition-colors"
                >
                  Start Your Brand
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-gray-500 hover:text-white transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Watermark & Copyright */}
        <div className="w-full flex justify-center items-end pointer-events-none select-none mb-8 relative">
          <div className="absolute inset-0 bg-gradient-to-t from-[#080808] via-transparent to-transparent z-10"></div>
          <img
            src={"./images/alldoer-footer.png"}
            alt="Alldoer Watermark"
            className="w-full max-w-5xl object-contain"
            style={{
              maskImage: 'linear-gradient(to top, transparent 0%, rgba(0,0,0,0.3) 30%, rgba(0,0,0,0.6) 60%, rgba(0,0,0,0.8) 100%)',
              WebkitMaskImage: 'linear-gradient(to top, transparent 0%, rgba(0,0,0,0.3) 30%, rgba(0,0,0,0.6) 60%, rgba(0,0,0,0.8) 100%)'
            }}
          />
        </div>
      </div>
      <div className="w-full bg-[#0E1419] pt-8 flex flex-col md:flex-row justify-around items-center text-xs md:text-sm text-gray-400">
        <p>© 2026 Alldoer Manufacturing. All rights reserved.</p>
        <p className="mt-2 md:mt-0">Connecting the world to quality.</p>
      </div>
    </footer>
  );
};

export default Footer;
